export default __webpack_public_path__ + "static/jamie-screenshot-829f49318da58b9a649f1e12f8a7dc6d.png";